var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c("div", { staticClass: "md-headline" }, [_vm._v(_vm._s(_vm.title))]),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid":
              _vm.formSubmitted && _vm.validations.name.$invalid
          }
        },
        [
          _c("label", [_vm._v("Name")]),
          _c("md-input", {
            attrs: { id: "input-name", maxlength: 200 },
            model: {
              value: _vm.entity.name,
              callback: function($$v) {
                _vm.$set(_vm.entity, "name", $$v)
              },
              expression: "entity.name"
            }
          }),
          _vm.formSubmitted && !_vm.validations.name.required
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e(),
          _vm.formSubmitted &&
          _vm.validations.name.required &&
          !_vm.validations.name.isUnique &&
          !_vm.validations.name.$pending
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("Must be unique")
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid":
              _vm.formSubmitted && _vm.validations.shortDescription.$invalid
          }
        },
        [
          _c("label", [_vm._v("Short Description")]),
          _c("md-input", {
            attrs: { id: "input-short-description", maxlength: 200 },
            model: {
              value: _vm.entity.shortDescription,
              callback: function($$v) {
                _vm.$set(_vm.entity, "shortDescription", $$v)
              },
              expression: "entity.shortDescription"
            }
          }),
          _vm.formSubmitted && !_vm.validations.shortDescription.required
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "md-input-container",
        {
          class: {
            "md-input-invalid":
              _vm.formSubmitted && _vm.validations.description.$invalid
          }
        },
        [
          _c("label", [_vm._v("Long Description")]),
          _c("md-textarea", {
            attrs: { id: "input-long-description", maxlength: 500 },
            model: {
              value: _vm.entity.description,
              callback: function($$v) {
                _vm.$set(_vm.entity, "description", $$v)
              },
              expression: "entity.description"
            }
          }),
          _vm.formSubmitted && !_vm.validations.description.required
            ? _c("span", { staticClass: "md-error" }, [
                _vm._v("This field is required")
              ])
            : _vm._e()
        ],
        1
      ),
      _c("md-chips", {
        attrs: {
          id: "input-chips",
          "md-max": 15,
          "md-input-placeholder": "Tags..."
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(chip) {
              return [_c("span", [_vm._v(_vm._s(chip.value))])]
            }
          }
        ]),
        model: {
          value: _vm.entity.tags,
          callback: function($$v) {
            _vm.$set(_vm.entity, "tags", $$v)
          },
          expression: "entity.tags"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1f84bc6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1f84bc6","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/MetadataForm.vue
// module id = 715
// module chunks = 0